import { render } from "./Helpdesk.vue?vue&type=template&id=7a650422"
import script from "./Helpdesk.vue?vue&type=script&lang=js"
export * from "./Helpdesk.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__